import React from 'react';
import HomeHero from './../components/home/hero';
import HomeAbout from './../components/home/about';
import HomeDomain from './../components/home/domains';

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <HomeHero />

      {/* About us Section */}
      <HomeAbout />

      {/* Domains Section */}
      <HomeDomain />
    </div>
  );
};

export default Home;
